import * as PIXI from 'pixi.js';
import GSOParasite from '../../../Game/Base/GSOParasite';
import Global from '../../../Game/Global';
import Vector from '../../../Game/Base/Math/Vector';
import CanvasImageButton from '../../CanvasImageButton';
import Angle from '../../../Game/Base/Math/Angle';
import { Shape } from '../../../Game/Level/Blok';
import AssetManager from '../../../Game/Base/AssetManager';
import MoveToCanvasButton from '../../MoveToCanvasButton';

// The overlay for GameKit ui elements within the canvas.
export default class SelectedBlokOverlay extends GSOParasite {
    constructor(realParent, stepParent) {
        super(realParent, stepParent);
        this.blokEditor = realParent;

        this.pixiContainer = null;
        this.pixiGraphics = null;

        this.rotateButton = new CanvasImageButton(this, AssetManager.get('img.btn_rotate'));
        this.rotateButton.position.x = -32 - 16;
        this.rotateButton.position.y = 32 + 16;
        this.rotateButton.onMouseDown = function(mousePositionP) {
            const mousePosition = this.getGame().canvasToGamePosition(mousePositionP);
            const blok = this._gsoParent.getAttachedStepParent();
            this.angleOffset = blok.rotation - Vector.getAngle(mousePosition, blok.position);
        };
        this.rotateButton.onMouseMove = function(mousePositionP) {
            const game = this.getGame();
            const mousePosition = game.canvasToGamePosition(mousePositionP);
            const blok = this._gsoParent.getAttachedStepParent();
            if (game.keys.ShiftLeft || game.keys.ShiftRight || game.keys.Shift) {
                blok.rotation = Angle.snap(Vector.getAngle(mousePosition, blok.position) + this.angleOffset, 45 / 4, 45 / 4 / 2);
            } else if (game.keys.Control || game.keys.ControlLeft || game.keys.ControlRight) {
                blok.rotation = Vector.getAngle(mousePosition, blok.position) + this.angleOffset;
            } else {
                blok.rotation = Angle.snap(Vector.getAngle(mousePosition, blok.position) + this.angleOffset, 45, 5);
            }
        };

        this.deleteButton = new CanvasImageButton(this, AssetManager.get('img.btn_delete'));
        this.deleteButton.onMouseUp = function() {
            if (this.validClick) {
                this._gsoParent._realParent.blokManager.deleteBlok(this._gsoParent.getAttachedStepParent());
                this._gsoParent._realParent.setSelectedBlok(null);
            }
            this.deleteValid = false;
        };

        this.copyButton = new CanvasImageButton(this, AssetManager.get('img.btn_copy'));
        this.copyButton.onMouseUp = function() {
            if (this.validClick) {
                const newBlok = this._gsoParent._realParent.blokManager.copyBlok(this._gsoParent.getAttachedStepParent());
            }
        };

        this.scaleUpButton = new CanvasImageButton(this, AssetManager.get('img.btn_up'));
        this.scaleUpButton.onMouseDown = function(mousePositionP) {
            const mousePosition = this.getGame().canvasToGamePosition(mousePositionP);
            this.mouseStart = mousePosition;
        };
        this.scaleUpButton.onMouseMove = function(mousePositionP) {
            let mousePosition = this.getGame().canvasToGamePosition(mousePositionP);
            const blok = this._gsoParent.getAttachedStepParent();
            mousePosition = Vector.rotateAround(mousePosition, this.mouseStart, -blok.rotation);
            let div = Math.round((this.mouseStart.y - mousePosition.y) / Global.NATIVE_BLOCK_SIZE);
            if (div !== 0 && blok.size.y + div <= 0) {
                div = -(blok.size.y - 1);
            }
            if (div !== 0 && blok.size.y + div > 0) {
                blok.size.y += div;
                blok.position = Vector.rotateAround(new Vector(blok.position.x, blok.position.y - (div * Global.NATIVE_BLOCK_SIZE) / 2), blok.position, blok.rotation);
                this.mouseStart = Vector.rotateAround(new Vector(this.mouseStart.x, this.mouseStart.y - div * Global.NATIVE_BLOCK_SIZE), this.mouseStart, blok.rotation);
                blok.requestNewVisuals();
            }
        };

        this.scaleDownButton = new CanvasImageButton(this, AssetManager.get('img.btn_down'));
        this.scaleDownButton.onMouseDown = function(mousePositionP) {
            const mousePosition = this.getGame().canvasToGamePosition(mousePositionP);
            this.mouseStart = mousePosition;
        };
        this.scaleDownButton.onMouseMove = function(mousePositionP) {
            let mousePosition = this.getGame().canvasToGamePosition(mousePositionP);
            const blok = this._gsoParent.getAttachedStepParent();
            mousePosition = Vector.rotateAround(mousePosition, this.mouseStart, -blok.rotation);
            let div = Math.round((mousePosition.y - this.mouseStart.y) / Global.NATIVE_BLOCK_SIZE);
            if (div !== 0 && blok.size.y + div <= 0) {
                div = -(blok.size.y - 1);
            }
            if (div !== 0 && blok.size.y + div > 0) {
                blok.size.y += div;
                blok.position = Vector.rotateAround(new Vector(blok.position.x, blok.position.y + (div * Global.NATIVE_BLOCK_SIZE) / 2), blok.position, blok.rotation);
                this.mouseStart = Vector.rotateAround(new Vector(this.mouseStart.x, this.mouseStart.y + div * Global.NATIVE_BLOCK_SIZE), this.mouseStart, blok.rotation);
                blok.requestNewVisuals();
            }
        };

        this.scaleLeftButton = new CanvasImageButton(this, AssetManager.get('img.btn_left'));
        this.scaleLeftButton.onMouseDown = function(mousePositionP) {
            const mousePosition = this.getGame().canvasToGamePosition(mousePositionP);
            this.mouseStart = mousePosition;
        };
        this.scaleLeftButton.onMouseMove = function(mousePositionP) {
            let mousePosition = this.getGame().canvasToGamePosition(mousePositionP);
            const blok = this._gsoParent.getAttachedStepParent();
            mousePosition = Vector.rotateAround(mousePosition, this.mouseStart, -blok.rotation);
            let div = Math.round((this.mouseStart.x - mousePosition.x) / Global.NATIVE_BLOCK_SIZE);
            if (div !== 0 && blok.size.x + div <= 0) {
                div = -(blok.size.x - 1);
            }
            if (div !== 0 && blok.size.x + div > 0) {
                blok.size.x += div;
                blok.position = Vector.rotateAround(new Vector(blok.position.x - (div * Global.NATIVE_BLOCK_SIZE) / 2, blok.position.y), blok.position, blok.rotation);
                this.mouseStart = Vector.rotateAround(new Vector(this.mouseStart.x - div * Global.NATIVE_BLOCK_SIZE, this.mouseStart.y), this.mouseStart, blok.rotation);
                blok.requestNewVisuals();
            }
        };

        this.scaleRightButton = new CanvasImageButton(this, AssetManager.get('img.btn_right'));
        this.scaleRightButton.onMouseDown = function(mousePositionP) {
            const mousePosition = this.getGame().canvasToGamePosition(mousePositionP);
            this.mouseStart = mousePosition;
        };
        this.scaleRightButton.onMouseMove = function(mousePositionP) {
            let mousePosition = this.getGame().canvasToGamePosition(mousePositionP);
            const blok = this._gsoParent.getAttachedStepParent();
            mousePosition = Vector.rotateAround(mousePosition, this.mouseStart, -blok.rotation);
            let div = Math.round((mousePosition.x - this.mouseStart.x) / Global.NATIVE_BLOCK_SIZE);
            if (div !== 0 && blok.size.x + div <= 0) {
                div = -(blok.size.x - 1);
            }
            if (div !== 0 && blok.size.x + div > 0) {
                blok.size.x += div;
                blok.position = Vector.rotateAround(new Vector(blok.position.x + (div * Global.NATIVE_BLOCK_SIZE) / 2, blok.position.y), blok.position, blok.rotation);
                this.mouseStart = Vector.rotateAround(new Vector(this.mouseStart.x + div * Global.NATIVE_BLOCK_SIZE, this.mouseStart.y), this.mouseStart, blok.rotation);
                blok.requestNewVisuals();
            }
        };
    }

    onCreateVisuals() {
        this.pixiContainer = new PIXI.Container();
        this.getParentPixiContainer().addChild(this.pixiContainer);

        this.pixiGraphics = new PIXI.Graphics();
        this.pixiContainer.addChild(this.pixiGraphics);

        this.blokEditor.selectedStateOverlay.requestNewVisuals();
    }

    onUpdateVisuals() {
        const blok = this.getAttachedStepParent();

        this.pixiGraphics.clear();
        const lineThickness = 4;
        this.pixiGraphics.lineStyle(lineThickness + 0.1, 0xfff200);
        if (blok.shape === Shape.rectangle) {
            this.pixiGraphics.drawRect(
                (-blok.size.x * Global.NATIVE_BLOCK_SIZE) / 2 + lineThickness / 2,
                (-blok.size.y * Global.NATIVE_BLOCK_SIZE) / 2 + lineThickness / 2,
                blok.size.x * Global.NATIVE_BLOCK_SIZE - lineThickness,
                blok.size.y * Global.NATIVE_BLOCK_SIZE - lineThickness
            );
        } else {
            this.pixiGraphics.drawCircle(0, 0, (blok.size.x * Global.NATIVE_BLOCK_SIZE - lineThickness) / 2);
        }

        this.updateButtonPositions();
    }

    updateButtonPositions() {
        const blok = this.getAttachedStepParent();

        let ySize = blok.size.y;
        if (blok.shape === Shape.circle) ySize = 1;

        this.rotateButton.position.y = (ySize * Global.NATIVE_BLOCK_SIZE) / 2 + 8;
        this.rotateButton.position.x = (-blok.size.x * Global.NATIVE_BLOCK_SIZE) / 2 - 8;

        this.deleteButton.position.y = (-ySize * Global.NATIVE_BLOCK_SIZE) / 2 - 8;
        this.deleteButton.position.x = (blok.size.x * Global.NATIVE_BLOCK_SIZE) / 2 + 32 + 8 + 8;

        this.copyButton.position.y = (-ySize * Global.NATIVE_BLOCK_SIZE) / 2 - 8;
        this.copyButton.position.x = (blok.size.x * Global.NATIVE_BLOCK_SIZE) / 2 + 8;

        const scaleButtonOffset = 4;
        this.scaleUpButton.position.y = (-ySize * Global.NATIVE_BLOCK_SIZE) / 2 - 4 - scaleButtonOffset;
        this.scaleDownButton.position.y = (ySize * Global.NATIVE_BLOCK_SIZE) / 2 + 4 + scaleButtonOffset;
        this.scaleLeftButton.position.x = (-blok.size.x * Global.NATIVE_BLOCK_SIZE) / 2 - 4 - scaleButtonOffset;
        this.scaleRightButton.position.x = (blok.size.x * Global.NATIVE_BLOCK_SIZE) / 2 + 4 + scaleButtonOffset;
    }

    onDestroyVisuals() {
        this.pixiContainer.destroy();
        this.pixiGraphics.destroy();
    }

    onUpdate(deltaTime) {
        const game = this.getGame();

        if (game.keys.Control && game.downKeys.d) {
            const newBlok = this._realParent.blokManager.copyBlok(this.getAttachedStepParent());
            game.downKeys.d = false;
        }
        if (game.downKeys.Delete) {
            this._realParent.blokManager.deleteBlok(this.getAttachedStepParent());
            this._realParent.setSelectedBlok(null);
        }
    }

    onAttach() {
        const blok = this.getAttachedStepParent();
        if (blok.shape === Shape.circle) {
            this.scaleUpButton.disable();
            this.scaleDownButton.disable();
        }
        this.updateButtonPositions();
    }

    onDetach() {
        this.scaleUpButton.enable();
        this.scaleDownButton.enable();
    }

    getMouseEventWorldPosition(evt) {
        const rect = this._realParent.canvas.getBoundingClientRect();
        return this._realParent.game.canvasToGamePosition(new Vector(evt.clientX - rect.left, evt.clientY - rect.top));
    }

    getMouseEventPosition(evt) {
        const rect = this._realParent.canvas.getBoundingClientRect();
        return new Vector(evt.clientX - rect.left, evt.clientY - rect.top);
    }
}
